import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Inspeccion30Y31Ano2024SGM() {
  return <CategoryPage category="inspeccion30Y31Ano2024SGM" pageTitle="Sistema de Gestión de Medición" />;
}

export default Inspeccion30Y31Ano2024SGM;
